export default __webpack_public_path__ + "static/media/u_b.243efae4.wav";